import { apiErrorCodes } from 'consts/api/apiErrorCodes';
import { commonTexts, settlementTexts } from 'consts/text';
import { getErrorMessageAndCode } from '../getErrorMessageAndCode';

export const settlementsVerifyErrorParser: (error: unknown, defaultMessage?: string) => string = (
    error,
    defaultMessage = commonTexts.errorMessages.unknown,
) => {
    const { code } = getErrorMessageAndCode(error);

    if (code === apiErrorCodes.PREVIOUS_MONTHLY_SETTLEMENT_NOT_VERIFIED) {
        return settlementTexts.children.verifySettlements.verifySettlementsErrorMessages
            .previousMonthlySettlementNotVerified;
    }

    if (code === apiErrorCodes.SETTLEMENT_IS_VERIFIED) {
        return settlementTexts.children.verifySettlements.verifySettlementsErrorMessages
            .settlementIsVerified;
    }
    if (code === apiErrorCodes.COST_SPLIT_AMOUNT_TOO_LARGE) {
        return settlementTexts.children.costAllocation.costSplitAmountTooLargeErrorMessage;
    }

    return defaultMessage;
};
